module.exports = __webpack_public_path__ + "static/img/link-preview-placeholder.7ba221e2.svg";